let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1va7H")).then(() => parcelRequire('cBS0e'));